<template>
	<div class="form-info">
		<transition name="form-info-slide">
			<div v-if="isOpen" class="info-panel row" ref="infoPanel">
				<div class="col-sm-12 title mb-3">
					<span>{{ this.$t('form-additional-info') }}</span>
					<button type="button" class="close-btn" :title="$t('close')" @click="closePanel">
						<i class="fal fa-times"></i>
					</button>
				</div>
				<div v-for="(item, index) in formattedItems" :key="index" class="col-sm-12 col-md-6 col-lg-3 p-0">
					<div class="form-group d-flex flex-column">
						<label class="col-form-label pl-0 pr-0">{{ item.label }}</label>
						<div class="form-info-value">
							<div :class="['p-2', { ltr: item.isDateTime }]">{{ item.value }}</div>
						</div>
					</div>
				</div>
			</div>
		</transition>
		<i class="fa fa-info handler" @click="togglePanel"></i>
	</div>
</template>
<script>
	import PersianDate from 'persian-date'

	export default {
		name: 'form-info',
		props: {
			data: {},
			options: {}
		},
		data() {
			return {
				isOpen: false,
				buttonOptions: {
					title: this.$t('reports.back'),
					isPrimary: false,
					isOutline: true,
					class: 'border-0 form-info-back',
				}
			}
		},
		computed: {
			items() {
				if (!this.data) return []
				return Array.isArray(this.data) ? this.data : Object.values(this.data)
			},
			formattedItems() {
				return this.items.map((item) => {
					const label = item[0]
					const rawValue = item[1]
					const type = item[2]
					let value = ''
					let isDateTime = false

					if (type === 'date') {
						value = this.getDate(rawValue)
					} else if (type === 'datetime') {
						value = this.getDateTime(rawValue)
						isDateTime = true
					} else if (rawValue !== undefined && rawValue !== null) {
						value = String(rawValue).toLocaleDigits ? String(rawValue).toLocaleDigits() : String(rawValue)
					}

					return {
						label,
						value,
						type,
						isDateTime
					}
				})
			},
			hasHint() {
				return !!this.$slots['hint']
			},
			hasLabel() {
				return (this.label && this.label.length)
			}
		},
		methods: {
			togglePanel() {
				this.isOpen = !this.isOpen
			},
			closePanel() {
				this.isOpen = false
			},
			onHandlerClick() {
				this.togglePanel()
			},
			getDateTime(gdate) {
				if (gdate) {
					let date = new Date(gdate)
					date = new PersianDate(date)
					return date.format('YYYY/MM/DD HH:mm:ss')
				}
				return ''
			},
			getDate(gdate) {
				if (gdate) {
					let date = new Date(gdate)
					date = new PersianDate(date)
					return date.format('YYYY-MM-DD')
				}
				return ''
			}
		}
	}
</script>
<style scoped>
	.close-btn {
		background: transparent;
		border: none;
		color: #314158;
		cursor: pointer;
		border-radius: 6px;
		width: 28px;
		height: 28px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		transition: color 0.15s, background-color 0.15s;
		padding: 0;
		outline: none;
		font-size: 18px;
	}

	.close-btn i {
		font-weight: 500;
	}

	.close-btn:hover {
		color: #1e293b;
		background-color: #f1f5f9;
	}

	.form-info-slide-enter-active,
	.form-info-slide-leave-active {
		transition: opacity 0.22s cubic-bezier(0.16, 1, 0.3, 1), transform 0.22s cubic-bezier(0.16, 1, 0.3, 1);
		will-change: opacity, transform;
	}

	.form-info-slide-enter-from,
	.form-info-slide-leave-to {
		opacity: 0;
		transform: translateY(-8px) scale(0.99);
	}

	.form-info-back {
		height: 32px;
	}
</style>
